@if (content() && layout() && atlas()) {
  <div
    class="relative flex flex-1 flex-col bg-cover"
    [ngStyle]="containerStyle | backgroundBucket"
    resizeObserver
    (resize)="resizeAtlas($event)"
    [caller]="'#sa3'"
  >
    @for (child of layout().children; track child.id) {
      <layout-container
        [child]="child"
        [config]="config()"
        [content]="content()"
        [options]="options"
        (renderEvent)="handleLayoutEvent($event)"
      ></layout-container>
    }

    <!-- - CHILD ACTIVATOR -->
    <!-- <div *ngIf="config.activeChild.slug && options.editor" class="emit-active-child">
    <button class="button" (click)="clickEmitActiveChild()">
      <i class="icon-pencil" *ngIf="!emitActiveChildContent">Edit this Visualization</i><i class="icon-ok" *ngIf="emitActiveChildContent">Finish editing</i>
    </button>
  </div> -->
  </div>
}
